$(document).ready(function() {
    var DOC = $(document);

    var jackpot__count,
        jackpot = $('[data-jackpot]'),
        jackpot_container = jackpot.find('.jackpots__slot');

    DOC.on('change', '[data-tabs-save="main_jackpots"]', function (){
        jackpot.find('.jackpots__handler').addClass('jackpots__handler--pressed');

        jackpot__count = localStorage.getItem('main_jackpots');

        jackpot_container.map(function (key, item) {
            $(item).slotMachine().shuffle(5);
        });

        setTimeout(function(){
            $('[data-jackpot-next]').removeClass('jackpots__handler--pressed');
        }, 1000);
    });


    DOC.on('click', '[data-jackpot-next]', function () {
        if(!$(this).hasClass('jackpots__handler--pressed')){
            let next_tab = parseInt(localStorage.getItem('main_jackpots')) + parseInt(1),
                total_tabs = parseInt(jackpot.find('.selectric-wrapper').find('li').length) - parseInt(1);

            if(next_tab > total_tabs){
                next_tab = 0;
            }

            jackpot.find('.selectric-wrapper').find('li:eq(' + next_tab + ')').trigger('click');
        }
    });

    jackpot_container.map(function (key, item) {
        $(item).slotMachine({
            active: localStorage.getItem('main_jackpots'), // стартуем с первого слайда
            delay: Math.floor(Math.random() * (500 - 300 + 100) + 300),
            randomize: function () {
                return jackpot__count;
            }
        });
    });

});